let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ORG4")).then(() => parcelRequire('gSXcf'));